import type { CriteriaItem } from '@/content-review/api'

export function isCriterionForSubjects(criterion: CriteriaItem, subjects: string[]): boolean {
  if (!criterion.subjects || criterion.subjects.length === 0) return true
  return criterion.subjects.some((subject) => subjects.includes(subject))
}
